var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page.title)?_c('div',[_c('structured-datas-job',{attrs:{"job":_vm.page}}),_c('builder',{attrs:{"data":_vm.page.layoutPage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }